import { createFileRoute, Link, notFound } from "@tanstack/react-router";

import { HubPlacePage, hubPlaceQuery } from "@/components/hubs/HubPlacePage";
import { hubPlaceHead } from "@/lib/hub-seo";

export const Route = createFileRoute("/bars/$slug")({
  loader: async ({ params, context }) => {
    const data = await context.queryClient.ensureQueryData(hubPlaceQuery("bars", params.slug));
    if (!data) throw notFound();
    return data;
  },
  head: ({ params, loaderData }) =>
    hubPlaceHead({ path: `/bars/${params.slug}`, locale: "en", loaderData }),
  component: BarsPlaceRoute,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div>
        <h1 className="font-heading text-2xl">Bar not available</h1>
        <Link to="/bars" className="mt-6 inline-block text-royal underline">
          Browse all bars
        </Link>
      </div>
    </div>
  ),
});

function BarsPlaceRoute() {
  const { slug } = Route.useParams();
  return <HubPlacePage hubSlug="bars" placeSlug={slug} locale="en" />;
}
